import './index.less';
import * as React from 'react';
import { connect } from 'react-redux';
import { getJournals } from 'modules/actions/smProjectDetail';
import Progress from './Progress';

export interface IndexProps {
  prefixCls?: string;
  getJournals: any;
  projectId: number;
  journals: any;
}

class Index extends React.Component<IndexProps, any> {
  public render() {
    return <Progress {...this.props} hasRemindButton={false} />;
  }
}

const mapState2Props = (state: any, ownProps: any) => {
  return {
    journals: state.smProjectDetail.journals,
  };
};

const mapDispatchToProps = {
  getJournals,
};

export default connect(
  mapState2Props,
  mapDispatchToProps,
)(Index);
